import './AmcAdPathFilters.scss';
import { Dropdown } from '@Components/Dropdown';
import { Placement, Size } from '@Components/designConstants';
import { AdTypeFilterGroup, AdTypeFilterOption } from './amc-pathing-analysis-types';

const FILTER_VALUES: AdTypeFilterOption['value'][] = ['include', 'exclude', 'require'];

interface AmcAdPathSelectionProps {
  value: AdTypeFilterOption['value'];
  label: string;
  width: number;
  onSelect: (value: AdTypeFilterOption['value']) => void;
}

const AmcAdPathSelection = ({ value, label, width, onSelect }: AmcAdPathSelectionProps) => (
  <div className='ad-path-dropdown-wrapper' style={{ width }}>
    <Dropdown
      overlayPlacement={Placement.RIGHT}
      size={Size.LG}
      onChange={onSelect}
      options={FILTER_VALUES}
      value={value}
      label={label}
    />
  </div>
);

interface AmcAdPathFilterMenuProps {
  filtersRowData: AdTypeFilterGroup[];
  onSelect: (value: AdTypeFilterOption['value'], rowIndex: number, filterIndex: number) => void;
}

export const AmcAdPathFilterMenu = ({ filtersRowData, onSelect }: AmcAdPathFilterMenuProps) => (
  <div className='ad-path-filters-menu'>
    {filtersRowData.map((row, rowIndex) => (
      <div className='ad-path-filters-row' key={row.label}>
        <div className='ad-path-filters-row-label'>{row.label}</div>
        <div className='ad-path-filters-wrapper'>
          {row.data.map((filter, filterIndex) => (
            <AmcAdPathSelection
              key={filter.name}
              value={filter.value}
              label={filter.label}
              width={row.columnWidth}
              onSelect={value => onSelect(value, rowIndex, filterIndex)}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);
